<template>
  <div class="order-step">
    <next-prev-menu
      :disabled="false"
      :previous="false"
      title="Naar Opleveren"
      @next-step="$router.push({ name: 'scanOrderDeliver' })"
    ></next-prev-menu>

    <pick-up
      :orderDetails="orderDetails"
      :shop="shop"
      :dates="dates"
      @updateOrder="updateOrder"
    ></pick-up>
  </div>
</template>

<script>
import { mapStores } from 'pinia'
import { useScanOrderStore } from '@/features/scanOrder/ScanOrder.store'
import NextPrevMenu from '@/components/NextPrevMenu.vue'
import OrderMixin from '@/mixins/OrderMixin'
import PickUp from '@/components/PickUp.vue'

export default {
  data() {
    return {}
  },
  mixins: [OrderMixin],
  components: {
    NextPrevMenu,
    PickUp
  },
  methods: {
    updateOrder(val) {
      this.scanOrderStore.updateOrderDetails(val[0], val[1])
    }
  },
  computed: {
    ...mapStores(useScanOrderStore),
    orderDetails() {
      return this.scanOrderStore.orderDetails
    },
    shop() {
      return this.scanOrderStore.shop
    },
    dates() {
      return this.scanOrderStore.pickUpDates
    }
  },
  created() {},
  watch: {}
}
</script>

<style lang="scss" scoped>
.card {
  //height: 590px;
}
</style>
